import {
  GridRenderEditCellParams,
  useGridApiContext,
} from "@mui/x-data-grid-pro";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export function isValidDate(value: any): boolean {
  if (value === null || value === undefined) {
    return false;
  }
  const date = new Date(value);
  return !isNaN(date.getTime()); // getTime() returns NaN for invalid dates
}

export function EditCustomDate(props: GridRenderEditCellParams<any, Date>) {
  const { value, id, field, date_format } = props;

  const apiRef = useGridApiContext();
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        value={
          isValidDate(value) ? moment(value) : value ? moment(value) : null
        }
        onChange={(date) => {
          let newDate = date;
          if (date_format === "YYYY" && date) {
            newDate = moment(date).startOf("year").add(1, "day");
          }
          apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newDate?.toDate() || null,
          });
        }}
        format={date_format || "MM/DD/YYYY"}
        views={["year"]}
        defaultValue={null}
        slotProps={{ field: { shouldRespectLeadingZeros: true } }}
      />
    </LocalizationProvider>
  );
}
